import type { Product } from './types'
import { orderProductsForShowcase } from './showcase-product-order'

type HomeFeaturedProductsView = 'launches' | 'products'

const normalizeOfferToken = (value: string | null | undefined) =>
  value?.trim().toLocaleLowerCase('pt-BR') || ''

const getOfferProductKey = (product: Product) => {
  const groupId = normalizeOfferToken(product.groupId)
  if (groupId) return `group:${groupId}`

  const code = normalizeOfferToken(product.code)
  if (code) return `code:${code}`

  const manufacturerCode = normalizeOfferToken(product.manufacturerCode)
  if (manufacturerCode) return `manufacturer:${manufacturerCode}`

  const name = normalizeOfferToken(product.name)
  if (name) return `name:${name}`

  return `id:${product.id}`
}

const distinctProductsByOfferKey = (products: Product[], excludedOfferKeys: Set<string>) => {
  const seenOfferKeys = new Set(excludedOfferKeys)
  const distinctProducts: Product[] = []

  for (const product of products) {
    const offerKey = getOfferProductKey(product)
    if (seenOfferKeys.has(offerKey)) continue

    seenOfferKeys.add(offerKey)
    distinctProducts.push(product)
  }

  return distinctProducts
}

export const selectHomeComboProducts = (
  featuredProducts: Product[],
  justArrivedProducts: Product[],
  featuredProductsView: HomeFeaturedProductsView,
  limit: number
) => {
  const productsWithoutJustArrivedDuplicates = featuredProductsView === 'products'
    ? distinctProductsByOfferKey(
        featuredProducts,
        new Set(justArrivedProducts.map((product) => getOfferProductKey(product)))
      )
    : featuredProducts
  const sourceProducts = productsWithoutJustArrivedDuplicates.length > 0
    ? productsWithoutJustArrivedDuplicates
    : featuredProducts

  return orderProductsForShowcase(sourceProducts, 'launches').slice(0, limit)
}
